<template>
	<div class="modal" :class="{'is-active' : isActive}">
		<div class="modal-background"></div>
		<div class="modal-content">
			<!-- Any other Bulma elements you want -->
			<div class="box">
				<NotificationContainer />
				<div v-if="register">
					<Register v-on:tryCloseModal="close" />
				</div>
				<div v-if="!register">
					<Login v-on:tryRegister="tryRegister" v-on:tryCloseModal="close" :gotoRoute="gotoRoute"/>
				</div>
			</div>
		</div>
		<button class="modal-close is-large" aria-label="close" @click="close"></button>
	</div>
</template>

<script>
import Login from '@/components/Login';
import Register from '@/components/Register';
import NotificationContainer from '@/components/NotificationContainer';
export default {
	components: { Login, NotificationContainer, Register },
	props: {
		active: {
			type: Boolean,
			default: false
		},
		register: {
			type: Boolean,
			default: false
		},
		gotoRoute:{
			type: Object,
			default: function() {
				return{
					name: 'jugar'
				}
			}
		}
	},
	name: 'LoginModal',

	data() {
		return {

		};
	},
	computed: {
		isActive(){
			return this.active;
		}
	},
	methods: {
		close(params){
			this.$emit('closeLogin',params)
		},
		tryRegister(){
			this.$emit('tryRegister')
		}
	},
};
</script>

<style lang="css" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
